import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Row } from "antd";
import { useModal } from "src/utils/overlay";
import { useAdBannerQuery } from "@/components/Banner/AdBanner";
import { HandoutAdBanner } from "@/components/Banner/AdBanner/HandoutAdBanner";
import { HandoutImageSection } from "@/components/Product/Handout/HandoutImageSection";
import getPreviewImage from "@/modules/products/utils/getPreviewImage";
import { Box, useTheme } from "@mui/material";
import { isBooksProduct } from "src/api/booksProducts";
import { HandoutCoreSection } from "./HandoutCoreSection";
import { Col, ProductDetailInfoWrapper } from "./HandoutProductDetail.style";
import { RelatedProduct } from "./RelatedProducts";
const HandoutProductDetailInfo = (param)=>{
    let { product , isFreepass , badgeText , freeTrialData  } = param;
    const [_, { open: openPreviewModal  }] = useModal("preview-modal");
    const theme = useTheme();
    const productType = isBooksProduct(product) ? product.productType : product.source_type;
    const isBooks = isBooksProduct(product);
    const thumbImg = isBooks ? product.thumbImg : product.thumb_img;
    const hasPreviewImg = getPreviewImage(product).length > 0;
    const { uciCode , publisherName , brandName  } = product;
    // 광고 배너 노출 여부 확인
    const adBannerSubject = isBooks ? product.subject : product.source.subject;
    const { noAdItems  } = useAdBannerQuery({
        position: "productDetail",
        subject: adBannerSubject
    });
    return /*#__PURE__*/ _jsxs(ProductDetailInfoWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    display: "flex",
                    flexWrap: "nowrap",
                    [theme.breakpoints.down("sm")]: {
                        flexWrap: "wrap",
                        gap: "20px"
                    }
                },
                children: [
                    /*#__PURE__*/ _jsx(HandoutImageSection, {
                        hasPreviewImg: hasPreviewImg,
                        uciData: uciCode || "",
                        isBooks: isBooks,
                        openPreviewModal: openPreviewModal,
                        thumbImg: thumbImg,
                        title: product.title,
                        product: isBooks ? undefined : product
                    }),
                    /*#__PURE__*/ _jsx(HandoutCoreSection, {
                        product: product,
                        productType: productType,
                        authorLabName: brandName || "",
                        publisherName: publisherName || "",
                        isFreepass: isFreepass,
                        badgeText: badgeText,
                        freeTrialData: freeTrialData
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Row, {
                children: /*#__PURE__*/ _jsx(Col, {
                    children: /*#__PURE__*/ _jsx(RelatedProduct, {
                        product: product,
                        isFreepass: isFreepass,
                        freeTrialData: freeTrialData,
                        hasAdBanner: !noAdItems
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Row, {
                children: /*#__PURE__*/ _jsx(Col, {
                    children: /*#__PURE__*/ _jsx(HandoutAdBanner, {
                        position: "productDetail",
                        subject: isBooks ? product.subject : product.source.subject
                    })
                })
            })
        ]
    });
};
export default HandoutProductDetailInfo;
